import { useState, useCallback } from 'react';

type UpdateState = {
  id: number | null,
  single: boolean,
}

export type MenuTargetItemState = [
  number | null,
  boolean,
  (update: UpdateState) => void
]

export default function useMenuTargetItemState(): MenuTargetItemState {
  const [state, setState] = useState<number | null>(null);
  const [singleAvailable, setSingleAvailable] = useState<boolean>(true);

  const handleUpdateState = useCallback(({ id, single }) => {
    setState(id);
    setSingleAvailable(single);
  }, []);

  return [state, singleAvailable, handleUpdateState];
}
